import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private config: any;

  public get settings() {
    return this.config;
  }

  init(config: any) {
    this.config = config;
  }
}
